module.exports = __webpack_public_path__ + "img/greyList3.e87c2fdc.png";